import './jscourse.component.css';

export function JSCourse() {
    return (
        <main id="main" className="site-main" role="main">
		   <article id="post-84" className="post-84 page type-page status-publish hentry">
			  <div className="entry-content">
				 <p data-adtags-visited="true"><strong>Topic 1: Java Script Introduction</strong></p>
				 <ul>
					<li>Introduction</li>
					<li>Where &amp; why to use?</li>
					<li>Syntax</li>
					<li>
					   <span>ECMA Script</span>
					   <ul>
						  <li>ES5</li>
						  <li>ES6</li>
					   </ul>
					</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 2: Java Script statements &amp; Variables</strong></p>
				 <ul>
					<li>Statements</li>
					<li>
					   Scope
					   <ul>
						  <li>Local</li>
						  <li>Global</li>
					   </ul>
					</li>
					<li>Var</li>
					<li>Let</li>
					<li>Const</li>
					<li>Comments</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 3:</strong> <strong>JS Operators</strong></p>
				 <ul>
					<li>Assignment</li>
					<li>Arithmetic</li>
					<li>Logical</li>
					<li>String Operators</li>
					<li>Type Operators</li>
					<li>Bitwise Operators</li>
					<li>String with Numbers</li>
				 </ul>
				 <p data-adtags-visited="true"><strong>Topic 4: Data types</strong></p>
				 <ul>
					<li>
					   Primitive types
					   <ul>
						<li>String</li>
						<li>Numbers</li>
						<li>Booleans</li>
						<li>Undefined</li>
					   </ul>
					</li>
					<li>Arrays</li>
					<li>
					   Objects
					   <ul>
					   	<li>Copy object</li>
						<li>New object</li>
						<li>NULL</li>
						<li>Empty</li>
						<li>Complex</li>
					   </ul>
					</li>
					
				 </ul>
				 <p><strong>Topic 5: JS Functions</strong></p>
				 <ul>
					<li>Function Syntax</li>
					<li>Function Invocation</li>
					<li>Void &amp; Return</li>
					<li>Function local &amp; global variables</li>
					<li>Error Handling</li>
				 </ul>
				 <p><strong>Topic 6: JS Conversions</strong></p>
				 <ul>
					<li>To String</li>
					<li>To Int</li>
					<li>To Float</li>
					<li>Object to serialized string</li>
					<li>Serialized string to Object</li>
				 </ul>
				 <p><strong>Topic 7: JS Events</strong></p>
				 <ul>
					<li>Click event</li>
					<li>Change event</li>
					<li>Load event</li>
					<li>Keyboard events</li>
					<li>Mouse events</li>
				 </ul>
				 <p><strong>Topic 8: JS String Methods &amp; Properties</strong></p>
				 <ul>
					<li>Length</li>
					<li>Property access</li>
					<li>Finding string in string</li>
					<li>Searching string in string</li>
					<li>Extracting string characters</li>
					<li>
					   Extracting string parts
					   <ul>
						  <li>Slice</li>
						  <li>Substring</li>
						  <li>Substr</li>
					   </ul>
					</li>
					<li>
					   Replacing string content
					   <ul>
						  <li>Replace</li>
						  <li>Regular expression</li>
					   </ul>
					</li>
					<li>Converting to Upper &amp; Lower case</li>
					<li>Concat</li>
					<li>Trim</li>
					<li>String Padding</li>
				 </ul>
				 <p><strong>Topic 9: JS Arrays</strong></p>
				 <ul>
					<li>Creating Array and access elements</li>
					<li>Array as Object</li>
					<li>Array Properties</li>
					<li>Array Methods</li>
					<li>Array Sort</li>
					<li>Array Iteration</li>
				 </ul>
				 <p><strong>Topic 10: JS Dates &amp; Math</strong></p>
				 <ul>
					<li>Create Dates – Years, Months, Day</li>
					<li>Date Methods</li>
					<li>Date Formats</li>
					<li>Date Get &amp; Set Methods</li>
					<li>
					   Math
					   <ul>
						  <li>Random</li>
						  <li>Boolean</li>
						  <li>Comparisons</li>
					   </ul>
					</li>
				 </ul>
				 <p><strong>Topic 11: JS Conditional Statements &amp; Loops</strong></p>
				 <ul>
					<li>
					   Conditional Statements
					   <ul>
						  <li>IF, IF ELSE</li>
						  <li>Switch</li>
					   </ul>
					</li>
					<li>
					   Loop
					   <ul>
						  <li>For</li>
						  <li>For In</li>
						  <li>For Of</li>
						  <li>While</li>
					   </ul>
					</li>
					<li>Break</li>
				 </ul>
				 <p><strong>Topic 12: JS RegExp</strong></p>
				 <ul>
					<li>Patterns</li>
					<li>Methods</li>
				 </ul>
				 <p><strong>Topic 13: JS Strict Mode &amp; this keyword &amp; JSON</strong></p>
				 <ul>
					<li>Strict cases</li>
					<li>this keyword</li>
					<li>
					   JSON
					   <ul>
						  <li>JSON Notation</li>
						  <li>JSON Object</li>
						  <li>JSON Array</li>
						  <li>JSON Serialization</li>
					   </ul>
					</li>
				 </ul>
				 <p><strong>Topic 14: Arrow Functions</strong></p>
				 <ul>
					<li>Syntax</li>
					<li>Return value by default</li>
					<li>With parameters</li>
				 </ul>
				 <p><strong>Topic 15: JS Classes</strong></p>
				 <ul>
					<li>Class</li>
					<li>Constructor</li>
					<li>Methods</li>
					<li>Inheritance</li>
					<li>Static</li>
				 </ul>
				 <p><strong>Topic 16: Commonly do Mistakes,</strong></p>
				 <p><strong>Performance,</strong></p>
				 <p><strong>Reserved Keywords</strong></p>
				 <p><strong>Topic 17: JS Functions Invocation &amp; Closures</strong></p>
				 <ul>
					<li>Invocation</li>
					<li>Call</li>
					<li>Apply</li>
					<li>Closures</li>
				 </ul>
				 <p><strong>Topic 18: JS Async</strong></p>
				 <ul>
					<li>Call backs</li>
					<li>Asynchronous</li>
					<li>Promise</li>
					<li>Async/ Await</li>
				 </ul>
				 <p><strong>Topic 19: JS HTML DOM</strong></p>
				 <ul>
					<li>Document</li>
					<li>Elements</li>
					<li>HTML</li>
					<li>CSS</li>
				 </ul>
				 <p><strong>TOPIC 20: JS HTML DOM Actions</strong></p>
				 <ul>
					<li>Events</li>
					<li>Event Listener</li>
					<li>Navigation</li>
					<li>Nodes</li>
					<li>Collections</li>
					<li>Node lists</li>
				 </ul>
				 <p><strong>Topic 21: JS Browser BOM</strong></p>
				 <ul>
					<li>Window</li>
					<li>Screen</li>
					<li>Location</li>
					<li>Navigator</li>
					<li>Popup Alert</li>
					<li>Timing</li>
					<li>Cookies</li>
				 </ul>
			  </div>
		   </article>
		</main>
    )
}